<template>
    <div>
        <div class="row">
            <div class="col-sm-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get('companies.title.contact-data') }}</h2>
                    </div>
                    <div class="box-body">
                        <text-input
                            :label="lang.get('global.companyname')"
                            :error="errors.get('name')"
                            v-model="form.name"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.phone')"
                            :error="errors.get('phone')"
                            v-model="form.phone"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.fax')"
                            :error="errors.get('fax')"
                            v-model="form.fax"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.email')"
                            :error="errors.get('email')"
                            v-model="form.email"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.url')"
                            :error="errors.get('url')"
                            v-model="form.url"
                        ></text-input>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get('companies.title.address-data') }}</h2>
                    </div>
                    <div class="box-body">
                        <text-input
                            :label="lang.get('global.address')"
                            :error="errors.get('address')"
                            v-model="form.address"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.zipcode')"
                            :error="errors.get('zipcode')"
                            v-model="form.zipcode"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.city')"
                            :error="errors.get('city')"
                            v-model="form.city"
                        ></text-input>
                        <country-select
                            :label="lang.get('global.country')"
                            :error="errors.get('country_id')"
                            v-model="form.country_id"
                        ></country-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get('companies.title.postal-data') }}</h2>
                    </div>
                    <div class="box-body">
                        <text-input
                            :label="lang.get('global.address')"
                            :error="errors.get('postal_address')"
                            v-model="form.postal_address"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.zipcode')"
                            :error="errors.get('postal_zipcode')"
                            v-model="form.postal_zipcode"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.city')"
                            :error="errors.get('postal_city')"
                            v-model="form.postal_city"
                        ></text-input>
                        <country-select
                            :label="lang.get('global.country')"
                            :error="errors.get('postal_country_id')"
                            v-model="form.postal_country_id"
                        ></country-select>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get('companies.title.financial-data') }}</h2>
                    </div>
                    <div class="box-body">
                        <text-input
                            :label="lang.get('global.bic')"
                            :error="errors.get('bic')"
                            v-model="form.bic"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.iban')"
                            :error="errors.get('iban')"
                            v-model="form.iban"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.vat_number')"
                            :error="errors.get('vat_number')"
                            v-model="form.vat_number"
                        ></text-input>
                        <text-input
                            :label="lang.get('global.coc_number')"
                            :error="errors.get('coc_number')"
                            v-model="form.coc_number"
                        ></text-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-right">
            <button
                class="btn btn-primary"
                :disabled="!canSubmit"
                @click="onSubmit"
            >
                {{ lang.get('global.save') }}
            </button>
        </div>
    </div>

</template>

<script>

import Lang from "../../../Lang";
import Errors from "../../../Errors";
import TextInput from "../../../components/Common/Form/TextInput";
import SelectInput from "../../../components/Common/Form/VueSelectInput";
import CountrySelect from "../../../components/Common/Form/CountrySelect";
import { mapGetters } from "vuex";

export default {

    components: {
        TextInput,
        SelectInput,
        CountrySelect,
    },

    computed: {
        ...mapGetters([
            'getCompany',
        ]),

        canSubmit() {
            return this.posting === false &&
                this.form.name !== '';
        },

        getPostRoute() {
            return this.edit === true ?
                this.route('api.v1.crm.companies.update', {uuid:this.getCompany.uuid}) :
                this.route('api.v1.crm.companies.store');
        },

        getPostData() {
            return this.form;
        },
    },

    data() {
        return {
            edit:false,
            errors:new Errors,
            form:{
                title:'',
                firstname:'',
                middlename:'',
                lastname:'',
                mobile:'',
                phone:'',
                phone_alt:'',
                email:'',
                email_alt:'',
                fax:'',
                url:'',
                address:'',
                zipcode:'',
                city:'',
                country_id:null,
            },
            lang:Lang,
            posting:false,
        }
    },

    metaInfo: {
        title:'Bedrijf formulier',
    },

    methods: {

        checkForEdit() {
            if (!this.$route.params.uuid) {
                return;
            }

            this.form = JSON.parse(JSON.stringify(this.getCompany));
            this.edit = true;
        },

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }

            this.posting = true;
            axios.post(this.getPostRoute, this.getPostData)
                .then(resp => {
                    this.$snotify.success('De bedrijfsgegevens zijn aangepast');
                    this.resetData();
                    this.$emit('companyDataChanged');
                    this.$router.push({name:'crm.companies.show', params:{uuid: resp.data.data.company_uuid}});
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van de bedrijfsgegevens'))
                .finally(() => this.posting = false);
        },

        resetData() {
            this.form = {
                title:'',
                firstname:'',
                middlename:'',
                lastname:'',
                mobile:'',
                phone:'',
                phone_alt:'',
                email:'',
                email_alt:'',
                fax:'',
                url:'',
                address:'',
                zipcode:'',
                city:'',
                country_id:null,
            };
            this.edit = false;
        },
    },

    mounted(){
        this.checkForEdit();
    },

    name: 'CrmCompaniesForm',

}

</script>
